module.exports = __webpack_public_path__ + "static/media/user.98e93df7.svg";